import { render, staticRenderFns } from "./AgentesPublicos.vue?vue&type=template&id=35047ad8&scoped=true"
import script from "./AgentesPublicos.vue?vue&type=script&lang=js"
export * from "./AgentesPublicos.vue?vue&type=script&lang=js"
import style0 from "./AgentesPublicos.vue?vue&type=style&index=0&id=35047ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35047ad8",
  null
  
)

export default component.exports